import React from "react";
import './style.css';
import SideLink from './../../components/SideLink';
import ReactHtmlParser from 'react-html-parser';


function Page1(props) {
  

  const { content }=props.data;
  


  function ImageDispaly(props) {
    return (
        <img src={props.image} />
    );
  }

  return (
    <div className="row page_3">
      <div className="col m3">
          <div className="side_nav_container">
            <SideLink custom_design={props.custom_design} lists={content} />
            </div>
      </div>
      <div className="col m9">
          <div class="content_container">
            {
                content.map((val)=>{
                    return (
                        <div className="item_box" id={'section-'+val.id} >
                            <h6 style={{borderColor:'#'+props.custom_design.colors[11].color,color:'#'+props.custom_design.colors[11].color}}>{val.title}</h6>
                            <p>{ReactHtmlParser(val.description)}</p>
                            <ImageDispaly image={val.full_path} />
                        </div>
                    )
                })
            }
            </div>
      </div>
    </div>
  );
}
export default Page1;
